import "../styles/ol.css";
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import TileWMS from 'ol/source/TileWMS';
import View from 'ol/View';
import {GPX, GeoJSON, IGC, KML, TopoJSON} from 'ol/format';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {Vector as VectorSource, XYZ} from 'ol/source.js';
import {Circle, Fill, Stroke, Style, Text} from 'ol/style';
import DragAndDrop from 'ol/interaction/DragAndDrop';
import LayerGroup from 'ol/layer/Group';
import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import "../styles/ol-ext.css";

const osmLayer = new TileLayer({
  title: 'OpenStreetMap',
    source: new OSM(),
 });
 const sandGravel = new TileLayer({
  title: 'Sand&Gravel',
  visible: true,
  source: new TileWMS({
    url: 'https://wms.focusedgeo.ca/geoserver/wms',
    params: {
      'Layers':'	FocusedGeo:sand_gravel_py_ll'
    }
  })
 });
 
const map = new Map({
  
      layers: [osmLayer, sandGravel],

  target: 'map',
  view: new View({
    //projection: 'ESPG:4326',
    //center: [0,0],
    center: [-13015000,7364000],
    zoom: 5,
  }),
});
const layerSwitcher = new LayerSwitcher();
map.addControl(layerSwitcher);
const extractStyles = document.getElementById('extractstyles');
let dragAndDropInteraction;

function setInteraction() {
  if (dragAndDropInteraction) {
    map.removeInteraction(dragAndDropInteraction);
  }
  dragAndDropInteraction = new DragAndDrop({
    formatConstructors: [
      GPX,
      GeoJSON,
      IGC,
       KML,
      TopoJSON,
    ],
  });
  dragAndDropInteraction.on('addfeatures', function (event) {
    const vectorSource = new VectorSource({
      features: event.features,
    });
    map.addLayer(
      new VectorLayer({
        source: vectorSource,
      })
    );
    map.getView().fit(vectorSource.getExtent());
  });
  map.addInteraction(dragAndDropInteraction);
}
setInteraction();

// extractStyles.addEventListener('change', setInteraction);

const displayFeatureInfo = function (pixel) {
  const features = [];
  map.forEachFeatureAtPixel(pixel, function (feature) {
    features.push(feature);
  });
  if (features.length > 0) {
    const info = [];
    let i, ii;
    for (i = 0, ii = features.length; i < ii; ++i) {
      info.push(features[i].get('name'));
    }
    document.getElementById('info').innerHTML = info.join(', ') || '&nbsp';
  } else {
    document.getElementById('info').innerHTML = '&nbsp;';
  }
};

map.on('pointermove', function (evt) {
  if (evt.dragging) {
    return;
  }
  const pixel = map.getEventPixel(evt.originalEvent);
  displayFeatureInfo(pixel);
});

map.on('click', function (evt) {
  displayFeatureInfo(evt.pixel);
});